<template id="simple-report-page">
  <section>
    <div class="ml-1">
      <div class="card-section">
        <div class="card"  :class="this.$store.state.bannerStatus ? 'banner-true' : 'banner-false'">
          <div class="card-header text-left d-flex justify-content-between align-items-center">
            <div>            <i class="fa fa-file"></i> {{repTitle}}
            </div>
            <div class="d-flex">
              <div class="input-group">
                <input type="text"
                       v-model="filterValue"
                       placeholder="Search on Display..."
                       class="form-control form-control-sm">
              </div>
              <div class="float-right">
                   <span v-for="(ai,index) in currentRepActionIconsData" :key="index">
          <download-csv v-if="ai.actionIconsName=== 'download'" class="btn btn-default" :data="cleanedDownload"
                        :name="momentAll" v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
            <i v-bind:id="ai.iconId" v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
               :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
               style="font-size:15px; float: right; margin-top: -3px; ">
            </i>
          </download-csv>

          <span v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
              <i v-if="ai.actionIconsName!== 'download'" v-bind:id="ai.iconId"
                 v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                 :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                 style="font-size:15px; padding-left:10px;">
              </i>
          </span>
        </span>
              </div>
            </div>

          </div>
          <div class="card-body">
            <div class="table-responsive" >
              <div>
                <table width="100%">
                  <tr>
                    <th class="thead-dark" align="center" v-for="key in dimSelectDpValues" v-bind:key="key"> {{key}}</th>
                  </tr>
                  <tr>
                    <td v-for="(key,index) in dimSelectDpValues" v-bind:key="key">
                      <v-select multiple style="padding: 5px"  v-bind:key="key" v-model="selectVal[rowsDataDimKeys[index]]" :options="getValues(rowsDataDimKeys[index],selectVal)">

                        <!--<option value="">All</option>
                        <option style="width: 30px;" :value="option" v-for="option in options[rowsDataDimKeys[index]]" :key="option">{{ option }}</option>-->
                      </v-select>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="grid-container" :style="{ height:$store.state.bannerStatus ? '72vh' : '79vh'}">
                <table class="table table-hover table-bordered">
                  <thead class="thead-dark" align="center">
                  <tr>
                    <th v-for="(col,index) in columns" v-bind:key="col">
                      {{col}}
                      <a href="#" @click="sortBy(Rcolumns[index])">
                        <i class="fa" v-bind:class=" sortKey.includes(Rcolumns[index]) ? (sortMap[Rcolumns[index]] === 'asc' ?  'fa-sort-amount-down-alt' : 'fa-sort-amount-up-alt') : 'fa-sort' " v-bind:style="[ sortKey.includes(Rcolumns[index]) ? {'color':'Gold'} : {'color':'White'}]" ></i>
                      </a>
                    </th>
                  </tr>
                  </thead>
                  <tbody >
                  <tr v-for="(rowd,index) in filteredItems" v-bind:key="index"  :class="{ 'highlight-row': index < rowsToHighlight }">
                    <template v-for="col in Rcolumns"  >
                       <template  v-if="col.startsWith('rm')" >
                          <td  v-bind:key="col" class="text-right" >{{comaSeperator(rowd[col])}}</td>
                       </template>
                       <template v-if="col.startsWith('rd') || col.startsWith('rr')">
                          <td  v-bind:key="col" class="text-left">{{rowd[col]}}</td>
                       </template>
                      <template v-if="col.startsWith('rp')">
                        <td  v-bind:key="col" class="text-right" >{{percentageFormat(rowd[col])}}</td>
                      </template>
                      <template v-if="rowd['rm7']>40">
                        <td v-bind:key="col" class="text-danger">{{rowd[col]}}</td>
                      </template>
                    </template>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
          <b-form-group label="Comment">
            <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
          </b-form-group>
        </b-modal>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'
import moment from "moment";

export default {
  name: 'simple-report-page',

  data: function() {
    return {
      output: [ ],
      repTitle:'',
      columns:[],
      keys: [ ],
      rowsdata: [ ],
      sortKey: [],
      sortOrder: ['asc'],
      sortMap:{},
      dimSelectDpValues: [],
      rowsDataDimKeys: [],
      filterValue: '',
      currentRepActionIconsData: {},
      cleanedDownload:[],
      iconOnChangeFlag: [],
      // This is much simpler if the select is it's own component.
      selectVal: {
        isActive: undefined,
        age: undefined,
        first_name: undefined,
        last_name: undefined
      },
      rowsToHighlight: 0
    }
  },
  created: function () {
    //this.loadCustomerSales()
    this.loadReportConfig()
    this.listenToRouter()
    this.resetAnnotationCount()

    axios.post('/api/update-last-seen')
        .then(response => {
          console.log('Last seen timestamp updated:', response.data)
        })
        .catch(error => {
          console.error('Failed to update last seen timestamp:', error)
        })

  },
  computed: {
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      console.log("row keyss",Object.keys(this.rowsdata[0]))
      return Object.keys(this.rowsdata[0])
    },
    "orderedData": function () {
      let result=this.rowsdata;
      if (this.filterValue) {
        result = result.filter(item => item.rd2.includes(this.filterValue));
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    filteredItems() {
      let result = this.rowsdata.filter(item => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.rowsDataDimKeys.forEach(key => {

          if(this.selectVal[key]){
            // console.log("filter ", this.selectVal,this.selectVal[key].length==0)
            keep =
                keep &&
                (this.selectVal[key].length==0  ||
                    //item[key] === this.selectVal[key]); // true && (false ||
                    this.selectVal[key].includes(item[key])); // true && (false ||
          }

        });

        return keep;
      });
      if (this.filterValue) {
        /* Filters the report Data based on the entered value in the generic search box
           loop over the keys of the inner object and use Array.some()
           It will work for any number of keys of any name so no need to get depend on the keys
           to get the match of the searched text use includes()
           to make the search non case sensitive use toLowerCase()
           to avoid NULL values in filtering excluded null values by taking !=Null and with && operator
           Numeric values gave obj[key].includes is not function error so converted them to string using toString()
        */
        result = result.filter(obj =>
            Object.keys(obj)
                .some(key => (obj[key] != null ) && obj[key].toString().toLowerCase().includes(this.filterValue.toLowerCase()))

        );


      }
      //console.log("SortMAp order",Object.keys(this.sortMap), this.sortKey, this.sortOrder)
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    getValues() {
      return (key1, x) => {
        // console.log("getValues ====> item", key1, x)
        var filteredData = this.example.filter((item) => {

          for (let kkk in x) { // loop over the keys of x
            //console.log("getValues >>>> ",kkk)

            if (x[kkk] && x[kkk].length > 0) { //check the value of each key is undefined/NULL or not
              //  console.log("getValues ,,,,",x[kkk],x[kkk].includes("All"))

              if (!x[kkk].includes('All')) { // check the value of the key doesn't contains All as a value
                // console.log("getValues,,,,", item[kkk], x[kkk])
                if (item[kkk] === undefined || !x[kkk].includes(item[kkk])) {

                  return false;
                }
              }
            }
            //  console.log("not entered if")
          }
          return true;
        });

        var whereClause='1==1 '
        for (let kkk in x){
          // console.log("kkk x ",kkk, x,x[kkk],whereClause + ' && ! x[kkk]'+ '.includes("item["' + kkk + '"]) ')
          if (x[kkk] && x[kkk].length > 0 && x[key1] && x[key1].length>0) { //check the value of each key is undefined/NULL or not
            if(kkk ==key1){ // check if it is for the passed key then make it as not in
              whereClause = whereClause + ' && !x["'+kkk+'"]' + '.includes(item["' + kkk + '"]) '
            }
            else{ //if not append and clause
              whereClause = whereClause + ' && x["'+kkk+'"]' + '.includes(item["' + kkk + '"])'
            }

          }
          else if(x[key1] && x[key1].length<=0){
            whereClause = whereClause + " && 1==2 "
          }
        }
        var example1 = _.clone(this.example)

        var invertFilteredData = example1.filter((item) => {

          if(eval(whereClause) && item){
            return true;
          }
          else{
            return false
          }

        })
        var firstArray = _.uniq(filteredData.map(kv => kv[key1]))
        var secondArray = []
        if(x[key1] && x[key1].length>0){
          secondArray= _.uniq(invertFilteredData.map(kv => kv[key1]))
        }

        var unionArray = _.union(firstArray,secondArray)
        console.log("union Array",unionArray);
        console.log("where clause",whereClause, x,key1,secondArray,invertFilteredData)

        return unionArray.sort((a, b) => {
          const isADate = this.isDateRelated(a);
          const isBDate = this.isDateRelated(b);

          // Both are date-related, sort by date in descending order
          if (isADate && isBDate) {
            return this.parseDate(b) - this.parseDate(a);
          }

          const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;

          // Special case: Month names (case insensitive)
          if (monthPattern.test(a) && monthPattern.test(b)) {
            const monthOrder = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
            const aNormalized = a.slice(0, 3).toLowerCase(); // Normalize to lowercase
            const bNormalized = b.slice(0, 3).toLowerCase();
            return monthOrder.indexOf(bNormalized) - monthOrder.indexOf(aNormalized);
          }

          // One is date-related and the other is not
          if (isADate) {
            return -1; // Move date-related items to the front
          }

          if (isBDate) {
            return 1; // Move date-related items to the front
          }

          // Both are not date-related, sort alphabetically or numerically
          if (typeof a === 'string' && typeof b === 'string') {
            return a.localeCompare(b); // Ascending order for strings
          } else if (typeof a === 'number' && typeof b === 'number') {
            return a - b; // Ascending order for numbers
          }

          // Handle mixed data types (string vs number)
          return (typeof a < typeof b) ? -1 : 1; // Strings before numbers
        }); //gets the unique values from the filteredData by mapping the passed key and sort the values in ascending order

//        console.log("where clause", x,key1)
      }

    },

    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      this.rowsDataDimKeys.forEach(key => {
        const vals = this.rowsdata.map(item => item[key]);
        console.log("Options Data Vals",vals);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals)).sort();
        console.log("Distinct Options Data ",options[key]);
      });

      return options;
    }
  },
  methods: {
    resetAnnotationCount() {
      // Store how many rows should be highlighted
      this.rowsToHighlight = this.$store.state.annotationCount;
      this.$store.commit("setAnnotationCount", 0);
      console.log('Rows to highlight:', this.rowsToHighlight);
    },
    isDateRelated(value) {
      if (!value) return false;

      const fiscalYearPattern = /^\d{6}$/; // e.g., 202324
      const yearPattern = /^\d{4}$/; // e.g., 2023
      const fullDatePattern = /^\d{8}$/; // e.g., 20231115
      const dashDatePattern = /^\d{4}-\d{2}$/; // e.g., 2023-11
      const dashFullDatePattern = /^\d{4}-\d{2}-\d{2}$/; // e.g., 2023-11-15

      // Pattern for month names (e.g., Jan, January, etc.)
      const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;


      return (
          fiscalYearPattern.test(value) ||
          yearPattern.test(value) ||
          fullDatePattern.test(value) ||
          dashDatePattern.test(value) ||
          dashFullDatePattern.test(value) ||
          monthPattern.test(value)
      );
    },

    parseDate(value) {
      if (!value) return 0;

      // Fiscal year format (YYYYMM)
      if (/^\d{6}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Year format (YYYY)
      if (/^\d{4}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Full date format (YYYYMMDD)
      if (/^\d{8}$/.test(value)) {
        return new Date(
            parseInt(value.slice(0, 4), 10), // Year
            parseInt(value.slice(4, 6), 10) - 1, // Month (0-based)
            parseInt(value.slice(6, 8), 10) // Day
        ).getTime();
      }

      // Dash-separated year-month format (YYYY-MM)
      if (/^\d{4}-\d{2}$/.test(value)) {
        const [year, month] = value.split('-').map(Number);
        return new Date(year, month - 1, 1).getTime(); // First day of the month
      }

      // Dash-separated full date format (YYYY-MM-DD)
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day).getTime();
      }

      // Month name (Jan, January, etc.)
      const monthMap = {
        jan: 0, january: 0,
        feb: 1, february: 1,
        mar: 2, march: 2,
        apr: 3, april: 3,
        may: 4,
        jun: 5, june: 5,
        jul: 6, july: 6,
        aug: 7, august: 7,
        sep: 8, september: 8,
        oct: 9, october: 9,
        nov: 10, november: 10,
        dec: 11, december: 11
      };


      const normalizedValue = value.trim().toLowerCase();
      for (const [key, month] of Object.entries(monthMap)) {
        if (normalizedValue === key.toLowerCase()) {
          return month; // Return the numeric month index
        }
      }

      return 0; // Default for non-date-related values
    },
    sortBy: function(key) {
      console.log("The sort Key is ",key)
      /*if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey=key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }*/
      if(Object.keys(this.sortMap).includes(key)){
        //rotate the sorting order asc-> desc-> remove sort
        this.sortMap[key]=='desc' ? delete this.sortMap[key]  : this.sortMap[key]='desc'
      }
      else{
        this.sortMap[key]='asc'
      }
      console.log("The sorting MAp",this.sortMap)
      this.sortKey=Object.keys(this.sortMap)
      this.sortOrder=Object.values(this.sortMap)
    },

    //Get Request
    /*loadCustomerSales: function () {
      axios.get('/api/v_retailer_monthly')
        .then(res => {
          this.rowsdata = res.data
          console.log('Test', this.rowsdata)
        }, err => {
          console.log('Error fetching data', err)
        })
    },*/
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.headerColumns= []
        setTimeout(() => {
          $this.loadReportConfig()
        }, 300)

      })
    },
    handleActionIconFunctionCall(fnName, index,x) {
      let val = !this.iconOnChangeFlag[index]
      this.$set(this.iconOnChangeFlag, index, val) //Array mutation happens only by set function or other mutation methods like slice,push,pop etc
      console.log("Handle function called with func name", fnName, this.iconOnChangeFlag,x)
      this[fnName](x)
    },

    commentBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      console.log(
          `ENTERED into the commentBox function(${id},${what.menuName}, ${what.reportName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.annotationHeader = "User Annotations";
      this.annotationTitle =
          this.annotationHeader + "->" + this.pg + "->" + this.section;
      this.$refs["comment-box"].show();
    },
    postAnnotation: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
      };
      axios.post(url, data).then(
          () => {
            this.$store.dispatch("loadAnnotations");
          },
          (e) => {
            this.$commonFn.auditLog(menu, subMenu, "", "POST", e);
            console.error("error in updating annotations", e);
          }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);

      this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success");
    },
    loadReportConfig: async function () {
      console.info('loading summary')
      let menuParam = this.$route.params.submenuId
      //  let submenuParam = this.$route.params.submenuId

      //Get Request
      axios.get('/api/reportConfigColumn/'+ menuParam,{
        headers: {
          'info-params': JSON.stringify({
            menuId: this.$route.params.menuId,
            submenuId: this.$route.params.submenuId
          }),
          'Content-Type': 'application/json'
        }
      } )
          //           axios.get('/api/reportConfigColumn/'+ menuParam +'/'+submenuParam)
          .then(res => {
            this.apiData = res.data
            this.rowsdata = this.apiData.rowsData
            this.repTitle = this.apiData.columns[0].reportName
            //this.columns = this.apiData.columns
            this.columns = this.apiData.columns.map(function (el) { return el.headerColumnDisplay; })
            this.icons = this.apiData.icons
            this.cleanedDownload = this.apiData.downloadRowsData
            this.momentAll = `${moment().format('YYYY-MM-DD hh:mm')}_${this.repTitle}.csv`
            console.log('ReportConfigRes',this.apiData)
            var rowsDataKeys = Object.keys(this.rowsdata[0])
            this.rowsDataDimKeys = rowsDataKeys.filter( dim => dim.includes('d'))
            this.dimSelectDpValues = this.columns.slice(0,this.rowsDataDimKeys.length)
            console.log('Dimension variables Keys',this.rowsDataDimKeys)
            console.log('Data for Report',this.rowsdata)
            console.log('Dimension variables Keys',this.dimSelectDpValues)
            //console.log('Report Title',this.apiData.columns[0].repName)
            //console.log('Report headers',this.nameArray)

            //Rep level action icons
            let actionIconsData = this.$store.state.actionIcons
            let repIcons = this.icons.filter(indi => indi.drilldownLevel == 'level1') // get only level1 for report level icons
            console.log('Rep Icons:', repIcons)
            var repActionIconsSyspkArray = repIcons[0].repActionIconsSyspkArray ? repIcons[0].repActionIconsSyspkArray : []
            console.log('Rep Action icons', repActionIconsSyspkArray, repIcons[0].repActionIconsSyspkArray)
            this.currentRepActionIconsData = actionIconsData.filter(r => repActionIconsSyspkArray.includes(r.syspk))
            console.log('Rep Action icons:',repActionIconsSyspkArray)

            const sorted = this.rowsdata.map(person => {
              let rtn = {}
              this.rowsDataDimKeys.forEach(key => {
                rtn[key] = person[key]
              })
              return rtn
            })
            this.example=[... new Set(sorted.map(JSON.stringify))].map(JSON.parse)
            //console.log("Distinct values of report data",sorted)


          }, err => {
            console.log('Error Fetching data', err)
          })

      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
      console.log("menuDetails",menuDetails);
      await this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "GET", "Success",this.$store.state.deviceType)

    },
    comaSeperator:function(n)
    {
      // n= n.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","); //modified due to safari ios reg not supporting issue
      n = n.toLocaleString()
      return n;
    },
    percentageFormat:function(a)
    {
      a= Math.round(a * 100) +'%';
      return a;
    },
  }
}
</script>
<style scope>
th {
  font-size: 12px;
}
.grid-container {
  overflow-y: auto;
}
td  {
  text-align: left;
}

.highlight-row{
  font-weight: bold;
}

.card-body {
  padding: 1px;
}

.banner-true{
  height: 86vh;
}

.banner-false{
  height: 93vh;
}


</style>